import React from 'react';
import Icon from '../AppIcon';

const TemplateCard = ({ template, selected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        relative w-full bg-card rounded-xl p-4 border-2 transition-all duration-300
        hover:shadow-romantic-md hover:scale-105 press-scale
        ${selected ? 'border-primary shadow-romantic-md' : 'border-border'}
      `}
    >
      {/* Template preview placeholder */}
      <div className="w-full aspect-[3/4] rounded-lg mb-3 overflow-hidden bg-gradient-to-br"
        style={{
          background: `linear-gradient(135deg, ${template.theme.colors.primary} 0%, ${template.theme.colors.secondary} 100%)`
        }}
      >
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-center p-4">
            <div className="text-white/90 text-xl font-semibold mb-2" style={{ fontFamily: template.theme.fonts.heading }}>
              {template.name}
            </div>
            <div className="text-white/70 text-sm" style={{ fontFamily: template.theme.fonts.body }}>
              {template.category}
            </div>
          </div>
        </div>
      </div>

      {/* Template info */}
      <div className="text-left">
        <h3 className="text-base font-semibold text-foreground mb-1 flex items-center justify-between">
          {template.name}
          {selected && (
            <Icon name="Check" size={20} color="var(--color-primary)" />
          )}
        </h3>
        <p className="text-xs text-muted-foreground line-clamp-2">
          {template.description}
        </p>
      </div>

      {/* Selected indicator */}
      {selected && (
        <div className="absolute top-2 right-2">
          <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
            <Icon name="Check" size={16} color="#FFFFFF" />
          </div>
        </div>
      )}
    </button>
  );
};

export default TemplateCard;
